/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-useless-path-segments */
/* eslint-disable no-unused-vars */
/* eslint-disable vars-on-top */
/* eslint-disable no-undef */
import * as Yup from 'yup';
import { useState, useRef,useEffect  } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import { useForm } from 'react-hook-form';

import axios from 'axios';
import Popup from 'reactjs-popup';

import 'reactjs-popup/dist/index.css';

import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import '../../../sections/auth/register/popup.css';
import { Link, Stack, IconButton, InputAdornment,Checkbox,FormControlLabel } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import useAuth from '../../../hooks/useAuth';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import Iconify from '../../../components/Iconify';
import { PATH_AUTH, PATH_DASHBOARD } from '../../../routes/paths';
import { FormProvider, RHFTextField, RHFCheckbox } from '../../../components/hook-form';

import ErrorSpan from '../verify-code/ErrorSpan';
import '../register/register_style.css';

export default function PopupLogin(props) {
  const open = props.open;
  const radio = props.radio;
  const onClose = props.onClose;
  const setType = props.setType;

  const { loginone } = useAuth();
  
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const isMountedRef = useIsMountedRef();

  const [showPassword, setShowPassword] = useState(false);

  const [passwordName, setPasswordName] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const loginIn = useRef(false);

  const [nameError, setNameError] = useState({
    emailError: null,
    passwordError: null,
  });

  const LoginSchema = Yup.object().shape({});

  const defaultValues = {
    email: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;
  const checkboxValues = localStorage.getItem("checkboxValue");
  
  const EmailValue = window.localStorage.getItem('email_popup');

  const password = window.localStorage.getItem('password');

  const accessToken = window.localStorage.getItem('accessToken');

  const userType = window.localStorage.getItem('user_type');

  window.localStorage.setItem('verifylogin', 'verifylogin');
  
  useEffect(()=>{
    if(checkboxValues === "checked" && EmailValue && password)
      {
     
      setRememberMe(checkboxValues);
      setPasswordName(password);
    
      } 
      else {
        setRememberMe("");
        setPasswordName("");
      }
    
    
    },[]);
    
    const handleRember = (event) => {
      if (event.target.checked) {
        setRememberMe(event.target.checked);
        localStorage.setItem("checkboxValue", "checked");
      
        localStorage.setItem('password', passwordName); // password is the user's password
      }
      else {
       localStorage.removeItem("checkboxValue");
       localStorage.removeItem("email");
       localStorage.removeItem("password");
      }
    
     
     
    };
  
   
  const onSubmit = async (data) => {
  

    const userid = window.localStorage.getItem('user_id');
    let error = {
      emailError: null,
      passwordError: null,
    };

    if (passwordName.trim().length === 0) {
      error = { ...error, passwordError: 'Password required' };
    }

    setNameError(error);
    if (error.emailError || error.passwordError) {
      return;
    }

   
   
    try {
      const result = await loginone(EmailValue, passwordName, radio);

      if (!result.success) {
        enqueueSnackbar(result.message.error);
      } else {

        setType(radio);
        enqueueSnackbar('Login successful!');

        if (result.status === 200) {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_API_URL}/web_register/add-user-type`,
              {
                user_type: radio,
              },
              {
                headers: {
                  Authorization: `Bearer ${result.accessToken}`,
                  'x-access-token': result.accessToken,
                },
              }
            );
          } catch (error) {
        enqueueSnackbar(error.response.data.error);
          }
        }

        loginIn.current = true;
        onClose();

        setTimeout(() => {
         

          navigate(PATH_DASHBOARD.root);
        }, 1000);
      }
    } catch (error) {
      
      reset();
      if (isMountedRef.current) {
        setError('afterSubmit', error);
      }
    }
  };
  return (
    <Popup
      className="popup-second"
      open={open}
      closeOnDocumentClick
    
    >
      <h4 style={{ textAlign:'center',color:'#000'}}>Login Form</h4>
      <div className="modal-popup">
           <a
          className="close"
          onClick={() => {
            onClose();
          }}
        >
          x
        </a>
      </div>

      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} >
          <RHFTextField
            type="email"
            name="email"
            label="Email address"
            value={EmailValue}
           className="email-poup-name"
       
          />
          {nameError.emailError ? <ErrorSpan error={nameError.emailError} /> : null}

          <RHFTextField
          className="password-type email-poup-name"
            name="password" 
            readOnly
            label="Password"
            type={showPassword ? 'text' : 'password'}
            value={passwordName}
            onChange={(e) => {
              setPasswordName(e.target.value);
              setNameError({ ...nameError, passwordError: '' });
            
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment className='password-sub-type' position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {nameError.passwordError ? <ErrorSpan error={nameError.passwordError} /> : null}
        </Stack>

        <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
      <FormControlLabel control={<Checkbox checked={rememberMe} onChange={handleRember} name="remember" />}
      label="Remember me" />

          <Link component={RouterLink} variant="subtitle2" to={PATH_AUTH.resetPassword}>
            Forgot password?
          </Link>
        </Stack>

        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}  >
          Login
        </LoadingButton>
      </FormProvider>

          
    </Popup>
  );
}
